class ConstProc {
    constructor(key, dateFrom, dateTo, value){
        this.key = key;
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.value = value;
        console.log('new object');
    }
}

export default ConstProc;